import { Map, Trip, Editor, Search } from './../classes.js';
import { event__element } from './../element/event.js';
import { trigger_text_editor, trigger_date_picker, trigger_sort, order_sort, can_display, random_string } from './../function/common.js';
import { api } from './../function/api.js';
import * as icon from './../vars/icons.js';

/*******
Using a custom class with the Leaflet/OpenStreetMap systems created a number of 
bugs and complications. I was hoping to standarize everything into a custom class, Button
we're going to just carefully run what we need to for the time being.

This will ensure that Leaflet systems are (cleanly) available as we need them, but it is a 
bit more annoying to organize.
*******/

//Register Vars
let active_marker = null;
let highlight_marker_id = null;
let highlight_marker = null;
let $active_button = null;
let displayed = {};
displayed.markers = {};
displayed.polygon = {};
var search_results = Array();
var search_markers = L.layerGroup();
let temp_rs_markers = Array();

const default_icon = L.icon({
	iconUrl: '/system/app/lib/img/home.png',
	iconSize: [20, 20],
	iconAnchor: [9, 30],
	popupAnchor: [-3, -36],
	shadowUrl: '/system/app/lib/img/pin.png',
	shadowSize: [40, 40],
	shadowAnchor: [19, 35]
});


/******
***
	SUPPORTING SYSTEMS
***
******/

//CENTER MAP ON TRIP CENTER
$('body').on('click', '.map__focus', function(e){
	e.preventDefault();
	Map.flyTo([Trip.content.trip.focus_lat, Trip.content.trip.focus_lng], Trip.content.trip.focus_zoom, {duration: .7});
});


//CENTER MAP ON EVENT
$('body').on('click', '.btn--focus_map', function(e){
	e.preventDefault();
	let m_id = $(this).attr('data-m_id');
	let block_id = $(this).closest('.e').attr('data-block_id');
	let el_id = $(this).closest('.e').attr('data-el_id');
	
	let marker = Trip.content.b[block_id].e[el_id].m[m_id];
	
	Map.flyTo([marker.lat, marker.lng], marker.zoom, {duration: .7});
	
	if(window.is_mobile){
		$('.mobile__map_switcher').trigger('click');
	}
});


//SET MAP FROM EVENT TO PLACE NEW MARKER via BUTTON CLICK
$('body').on('click', '.btn--marker', function(e){
	e.preventDefault();
	
	if(button_marker($(this))){
		if($(this).hasClass('btn--marker--active')){
			set_button_state($(this), 'update');
			set_map_state('read');
		}else{
			set_button_state($(this), 'updating');
			set_map_state('update');
		}
	}else{
		if($(this).hasClass('btn--marker--active')){
			button_marker($(this)) ? set_button_state($(this), 'update') : set_button_state($(this), 'place');
			set_map_state('read');
		}else{
			set_button_state($(this), 'placing');
			set_map_state('active');
		}
	}
});


//HIGHLIGHT A MARKER WHEN EVENT IS HOVERED
$('body').on({
	
    mouseenter: function (e) {
		var map_bounds = Map.getBounds();
		var marker_lat_lng = {};
		let el = {};
		let el_id = $(this).attr('data-el_id');
		let block_id = $(this).attr('data-block_id');
		if(block_id == 'trip'){return;}
		
        if($(this).attr('data-marker') !== undefined && $(this).attr('data-marker') !== 'undefined' && $(this).attr('data-marker') > 0 && $(this).attr('data-marker') != highlight_marker_id){
			highlight_marker_id = $(this).attr('data-marker');
			el = Trip.content.b[block_id].e[el_id];
			highlight_marker = displayed.markers[highlight_marker_id];
			marker_lat_lng = highlight_marker.getLatLng();
			
			if (map_bounds.contains(marker_lat_lng)) {
				set_marker_click(highlight_marker, el);
				highlight_marker.openPopup();
			}
		}
    },
    mouseleave: function (e) {
		if(($active_button == null && highlight_marker_id != null) || (highlight_marker_id != null && typeof($active_button.attr('data-marker')) != 'undefined' && $active_button.attr('data-marker') != highlight_marker_id)){
			highlight_marker.closePopup();
			highlight_marker_id = null;
			highlight_marker = null;
		}
    }
}, ".e.event");



//REGISTER AN NEW MARKER
export function register_marker(pin, data, m_id){
	var popup = L.popup();
	
	//Register Marker
	var marker = L.marker(
		pin.latlng,
		pin.options
	).addTo(Map);
	marker.bindPopup("");
	marker.m_id = m_id;
	
	set_marker_click(marker, data);
	
	displayed.markers[marker._leaflet_id] = marker;
	return marker._leaflet_id;
}


//Update Marker Display
export function update_marker_display(m){
	let update = displayed.markers[m.marker];
	let marker_display = icon.get_marker_display(m);
	
	update.setIcon(marker_display);
}


//UPDATE THE POPUP FOR A MARKER
export function set_marker_click(marker, data){
	let marker_id = 0;
	
	if(map_state() == 'active' || map_state() == 'update'){
		
		if(marker.m_id != undefined && !isNaN(marker.m_id)){
			if(marker != undefined && $active_button.attr('data-marker') == marker._leaflet_id){
				marker.getPopup().setContent(`
					<div>
						<h6>${data.c.name}</h6>
						<button data-m_id="${marker.m_id}" data-marker="${marker._leaflet_id}" class="btn btn--quaternary btn--tiny map--remove_existing_marker">Remove Association</button>
					</div>
				`);
			}else{
				marker.getPopup().setContent(`
					<div>
						<h6>${data.c.name}</h6>
						<button data-m_id="${marker.m_id}" data-marker="${marker._leaflet_id}" class="btn btn--primary btn--tiny map--set_existing_marker">Use Location</button>
					</div>
				`);
			}
		}
	}else{
		if(marker.m_id != undefined && !isNaN(marker.m_id)){
			let web_btn = '';
			
			if(can_display(data.c.location_link)){
				web_btn = `<a href="${data.c.location_link}" target="_blank" class="btn btn--secondary btn--tiny">Website</a>`;
			}
			
			marker.getPopup().setContent(`
				<div>
					<h6>${data.c.name}</h6>
					<a target="_blank" href="https://www.google.com/maps/dir//${marker._latlng.lat},${marker._latlng.lng}" class="btn btn--primary btn--tiny">Directions</a>
					${web_btn}
				</div>
			`);
		}
	}
}




//UPDATE THE DATA FOR A MARKER AND ASSOCIATED DOM ELEMENTS ON CHANGE
export function update_marker_data(marker){
	
	//update anything that shares the db marker id to the new leaflet id
	$(`[data-m_id="${marker.m_id}"]`).attr('data-marker', marker._leaflet_id);
	
	//check every element on the page
	$(`.e.card--event`).each(function(){
		//if it doesn't have a marker, or the marker doesn't match the old ID ignore it
		if(typeof($(this).attr('data-marker')) == 'undefined'){
			return;
		}else if($(this).attr('data-marker') != marker._leaflet_id){
			return;
		}
		
		//if we have a match, get the data for this element
		let temp_el = $(this).attr('data-el_id');
		let temp_block = $(this).attr('data-block_id');
		let temp_style = $(this).find(`[name="b[${temp_block}][e][${temp_el}][c][style]"]`).val();
		
		//update the object so page interactions continue to run smoothly
		if(typeof(Trip.content.b[temp_block].e[temp_el].m) == 'undefined'){
			Trip.content.b[temp_block].e[temp_el].m = {}
		}
		if(typeof(Trip.content.b[temp_block].e[temp_el].m[marker.m_id]) == 'undefined'){
			Trip.content.b[temp_block].e[temp_el].m[marker.m_id] = {}
		}
		Trip.content.b[temp_block].e[temp_el].m[marker.m_id].marker = marker._leaflet_id;
		Trip.content.b[temp_block].e[temp_el].m[marker.m_id].marker = marker._leaflet_id;
		Trip.content.b[temp_block].e[temp_el].m[marker.m_id].lat = marker._latlng.lat;
		Trip.content.b[temp_block].e[temp_el].m[marker.m_id].lng = marker._latlng.lng;
		Trip.content.b[temp_block].e[temp_el].m[marker.m_id].zoom = Map.getZoom();
		Trip.content.b[temp_block].e[temp_el].m[marker.m_id].type = temp_style;
		
		//update the data for submission to the database
		$(this).find('input.m_id').attr('name', `b[${temp_block}][e][${temp_el}][m][${marker.m_id}][id]`);
		$(this).find('input.m_id').val(marker.m_id);
		$(this).find('input.lat').attr('name', `b[${temp_block}][e][${temp_el}][m][${marker.m_id}][lat]`);
		$(this).find('input.lat').val(marker._latlng.lat);
		$(this).find('input.lng').attr('name', `b[${temp_block}][e][${temp_el}][m][${marker.m_id}][lng]`);
		$(this).find('input.lng').val(marker._latlng.lng);
		$(this).find('input.zoom').attr('name', `b[${temp_block}][e][${temp_el}][m][${marker.m_id}][zoom]`);
		$(this).find('input.zoom').val(Map.getZoom());
		$(this).find('input.type').attr('name', `b[${temp_block}][e][${temp_el}][m][${marker.m_id}][type]`);
		$(this).find('input.type').val(temp_style);
	});
}


//RUN MAPCLICK SYSTEM
export function on_map_click(e) {

	if($('#map').hasClass('user_map')){
		return user_map_click(e);
	}
	
	let zoom = Map.getZoom();
	let response = {};
	let block_id = $active_button.closest('.editable').attr('data-block_id');
	let el_id = $active_button.closest('.editable').attr('data-el_id');
	let m_id = $active_button.attr('data-m_id');
	let old_marker_id = 0;
	if(active_marker != null){
		old_marker_id = active_marker._leaflet_id;
	}
	
	// Clear existing marker, if it exists
	if (active_marker !== null) {
		Map.removeLayer(active_marker);
		delete displayed.markers[active_marker._leaflet_id];
	}

	// Add a new marker and update the active marker reference
	if(block_id == 'trip'){
		active_marker = L.marker([e.latlng.lat, e.latlng.lng]).addTo(Map); //add & update active
	}else{
		active_marker = L.marker([e.latlng.lat, e.latlng.lng], {icon: icon.get_marker_display(Trip.content.b[block_id].e[el_id].m[m_id])}).addTo(Map); //add & update active
	}
	active_marker.m_id = m_id;
	displayed.markers[active_marker._leaflet_id] = active_marker; //add new ref to array of displayed markers
	
	//update the Trip Object
	if(block_id == 'trip'){
		Trip.content.trip.marker = active_marker._leaflet_id;
	}else{
		update_marker_data(active_marker);
		
		//set the content for the popup
		if(m_id != undefined && !isNaN(m_id)){
			active_marker.bindPopup("");
			set_marker_click(active_marker, Trip.content.b[block_id].e[el_id]);
		}
	}
	
	//return lat & lng back
	response.origin = e.latlng;
	response.zoom = zoom;
	
	return response;
}

function user_map_click(e){
	let zoom = Map.getZoom();
	let response = {};
	
	$('.zoom_focus').val(zoom);
	$('.lat_focus').val(e.latlng.lat);
	$('.lng_focus').val(e.latlng.lng);
	
	if (active_marker !== null) {
		Map.removeLayer(active_marker);
	}
	active_marker = L.marker([e.latlng.lat, e.latlng.lng]).addTo(Map);
	
	//return lat & lng back
	response.origin = e.latlng;
	response.zoom = zoom;
	
	return response;
}



//SET MARKER BUTTON DETAILS FROM MARKER POPUP
$('body').on('click', '.map--set_existing_marker', function(e){
	let active_marker = displayed.markers[$(this).attr('data-marker')];
	let block_id = $active_button.closest('.editable').attr('data-block_id');
	let el_id = $active_button.closest('.editable').attr('data-el_id');
	let m_id = $(this).attr('data-m_id');
	let prev_id = $active_button.attr('data-m_id');
	active_marker.m_id = m_id;
	
	//remove the existing marker reference
	delete(Trip.content.b[block_id].e[el_id].m[prev_id]);
	
	// Add a new marker and update the active marker reference
	$active_button.attr('data-marker', active_marker._leaflet_id); //update button leaflet id
	$active_button.attr('data-m_id', m_id); //update button db id
	$active_button.closest('.e').attr('data-m_id', active_marker.m_id); //update element
	$active_button.closest('.e').attr('data-marker', active_marker._leaflet_id); //update element
	displayed.markers[active_marker._leaflet_id] = active_marker; //add new ref to array of displayed markers
	
	// update the data for this
	update_marker_data(active_marker);
	
	//set the content for the popup
	set_marker_click(active_marker, Trip.content.b[block_id].e[el_id]);
	set_button_state($active_button, 'update');
	set_map_state();
});



//REMOVE MARKER BUTTON DETAILS FROM MARKER POPUP
$('body').on('click', '.map--remove_existing_marker', async function(e){
	e.preventDefault();
	
	//GET THE KEY VARS
	let _leaflet_id = $(this).attr('data-marker');
	let active_marker = displayed.markers[_leaflet_id];
	let block_id = $active_button.closest('.editable').data('block_id');
	let el_id = $active_button.closest('.editable').data('el_id');
	let m_id = $(this).attr('data-m_id');
	let new_m = random_string(9);

	
	//REMOVE FROM THE DATABASE
		//always remove from the bridge table
		//then if count for latlng_id in bridge == 0, remove from latlng
	let delete_marker = new FormData();
	delete_marker.append('el_id', el_id);
	delete_marker.append('m_id', m_id);
	
	//post
	let response = await api('/api/marker/delete', delete_marker);
	
	//response
	if(response.error){
		this_response.classList.add('response--error');
		this_response.textContent = response.message.join('\n');
	}else{
	//On success, remove from 
		//Trip Object
		//, Displayed Markers object
		//, and Map if no other event uses it
		
		delete Trip.content.b[block_id].e[el_id].m[m_id];
		//Reset Marker button for the event
		Trip.content.b[block_id].e[el_id].m[new_m] = {};
		$active_button.attr('data-m_id', new_m);
		$active_button.attr('data-marker', 'undefined');
		$active_button.closest('.editable').attr('data-marker', 'undefined');
		
		$active_button.siblings('.id').attr('name', `b[${block_id}][e][${el_id}][m][${new_m}][id]`);
		$active_button.siblings('.id').val(new_m);
		if($('.lat_focus').length > 0){
			$('.lat_focus').attr('name', `b[${block_id}][e][${el_id}][m][${new_m}][lat]`);
			$('.lat_focus').val(``);
		}
		if($('.lng_focus').length > 0){
			$('.lng_focus').attr('name', `b[${block_id}][e][${el_id}][m][${new_m}][lng]`);
			$('.lng_focus').val(``);
		}
		if($('.zoom_focus').length > 0){
			$('.zoom_focus').attr('name', `b[${block_id}][e][${el_id}][m][${new_m}][zoom]`);
			$('.zoom_focus').val(``)
		}
		
		if(response.data.removed == true){
			Map.removeLayer(active_marker);
			delete displayed.markers[_leaflet_id];
		}
		set_map_state();
		set_button_state($active_button, 'place');
	}
	
});



//SET BUTTON STATE
export function set_button_state($btn, action = '') {
	reset_button_state(); //reset all buttons
	
	if(window.is_mobile){
		$('.mobile__map_switcher').trigger('click');
	}
	
	//set this button based on the action required
	switch(action){
		case 'updating':
			$btn.addClass('btn--marker--active');
			$btn.text('Updating Marker');
			
			$btn.siblings('.lat').addClass('lat_focus');
			$btn.siblings('.lng').addClass('lng_focus');
			$btn.siblings('.zoom').addClass('zoom_focus');
			
			active_marker = displayed.markers[button_marker($btn)];
			$active_button = $btn;
			break;
			
		case 'update':
			$btn.addClass('btn--marker--update');
			$btn.removeClass('btn--marker--place');
			$btn.text('Update Marker');
			
			active_marker = null;
			$active_button = null;
			break;
			
		case 'placing':
			$btn.addClass('btn--marker--active');
			$btn.text('Placing Marker');
			
			$btn.siblings('.lat').addClass('lat_focus');
			$btn.siblings('.lng').addClass('lng_focus');
			$btn.siblings('.zoom').addClass('zoom_focus');
			
			active_marker = null;
			$active_button = $btn;
			break;
			
		case 'place':
			$btn.addClass('btn--marker--place');
			$btn.removeClass('btn--marker--update');
			$btn.text('Place Marker');
			
			active_marker = null;
			$active_button = null;
			break;
			
		default:
			$btn.removeClass('btn--marker--active');
			$btn.text('Error');
	}
}



//SET ALL BUTTONS TO BASIC STATE
export function reset_button_state(){
	$('.lat').removeClass('lat_focus');
	$('.lng').removeClass('lng_focus');
	$('.zoom').removeClass('zoom_focus');
	
	$('.btn--marker').each(function(index){
		$(this).removeClass('btn--marker--active');
		
		if($(this).hasClass('btn--marker--place')){
			$(this).text('Place Marker');
		}
		
		if($(this).hasClass('btn--marker--update')){
			$(this).text('Update Marker');
		}
	});
}


//GET BUTTON MARKER
export function button_marker($btn){
	if(typeof($btn.attr('data-marker')) != 'undefined' && $btn.attr('data-marker') != '' && $btn.attr('data-marker') > 0){
		return $btn.attr('data-marker');
	}
	
	return false;
}



//SET MAP STATE
export function set_map_state(action = '') {
	
	switch(action){
		case 'active':
			$('.map__state').addClass('map__state--active');
			$('.map__mode').text('Click to Drop Pin');
			break;
		case 'update':
			$('.map__state').addClass('map__state--update');
			$('.map__mode').text('Updating Marker');
			break;
		default:
			$('.map__state').removeClass('map__state--active');
			$('.map__state').removeClass('map__state--update');
			$('.map__mode').text('Read Only Mode');
	}
	
	//update the marker pop-ups based on the map state
	for (const [leaflet_id, marker] of Object.entries(displayed.markers)) {
		if(typeof(displayed.markers[leaflet_id]) == 'undefined'){
			//don't try and do anything with a missing marker
		}else{
			let block_id = $(`.e[data-marker="${leaflet_id}"]`).attr('data-block_id');
			let el_id = $(`.e[data-marker="${leaflet_id}"]`).attr('data-el_id');
			
			if(block_id != 'trip' && block_id != undefined){
				set_marker_click(displayed.markers[leaflet_id], Trip.content.b[block_id].e[el_id]);
			}
		}
	}
	
}



//GET MAP STATE
export function map_state() {
	if($('.map__state').hasClass('map__state--active')){
		return 'active';
	}
	if($('.map__state').hasClass('map__state--update')){
		return 'update';
	}
	
	return false;
}



//DISPLAY MAP ERROR
export function map_error(error = ['active', 'update']) {
	let error_text = '';
	if(error.includes('active') && error.includes('update')){
		error_text = 'Action Unavailable in Read Only Mode';
	}else if(error.includes('active')){
		error_text = 'Action Unavailable in Read Only & Update Modes';
	}else if(error.includes('update')){
		error_text = 'Action Unavailable in Read Only & Active Modes';
	}
	
	$('.map__response').text(error_text);
	$('.map__response').addClass('map__response--error');
	$('.map__response').fadeIn(700).delay(3500).fadeOut(700);
	
	setTimeout(function() {
		$('.map__response').removeClass('map__response--error');
	}, 5200);
}



//REMOVE ALL MARKERS FROM MAP
export function clean_map_view(){
	console.log('** CLEANING MAP **');
	
	Map.eachLayer(function (layer) {
		if (layer instanceof L.Marker) {
			Map.removeLayer(layer);
		}
	});
	
	displayed.markers = {};
	displayed.polygon = {};
}





/****
**
** NEW EVENT FROM MAP SYSTEMS & SEARCH
** NEW EVENT FROM MAP SYSTEMS & SEARCH
** NEW EVENT FROM MAP SYSTEMS & SEARCH
**
****/

$('body').on('click', '.map__search button', async function(e){
	e.preventDefault();
	
	const this_form = e.target.closest('form');
	const formData = new FormData(this_form);
	const m = Map.getBounds();
	
	search_results = await fetch(`https://nominatim.openstreetmap.org/search?q=${formData.get('q')}&format=json&addressdetails=1&viewbox=${m._northEast.lng},${m._northEast.lat},${m._southWest.lng},${m._southWest.lat}&bounded=1`, {
		method: 'GET',
		headers: {
				'Accept': 'application/json'
		}
	}).then((e) => {
		return e.json();
	});
	
	if(search_results.length > 0){
		console.log('build search results');
		build_search_results(search_results);
	}else{
		console.log('build no results');
	}
});



//REMOVE SEARCh MARKERS FROM MAP
export function clean_search(){
	search_markers.clearLayers();
}



export function build_search_results(results){
	temp_rs_markers = Array();
	clean_search();
	
	results.forEach(function(rs, index) {
		let mark = L.marker([rs.lat, rs.lon], {icon: icon.search_icon}).bindPopup(`
			<div>
				<h5>${rs.name}</h5>
				<button data-mark="${index}" class="btn btn--secondary btn--tiny new_event_from_map">New Event</button>
				<button data-mark="${index}" class="btn btn--primary btn--tiny new_marker_from_map">Add to Event</button>
			</div>
		`);
		
		temp_rs_markers.push(mark);
		search_results[index].marker = mark;
	});
	
	search_markers = L.layerGroup(temp_rs_markers);
	search_markers.addTo(Map);
}



function map_event(rs, block_id){
	let el_id = random_string(9);
	let m_id = random_string(9);
	let data = Editor.create_empty_data('event', block_id, el_id, m_id);
	
	console.log('adding event');
	
	//We have some default values from the search, update the data before creating the event
	Trip.content.b[block_id].e[el_id].c['name'] = rs.name;
	Trip.content.b[block_id].e[el_id].m[m_id]['marker'] = rs.marker._leaflet_id;
	Trip.content.b[block_id].e[el_id].m[m_id]['lat'] = rs.lat;
	Trip.content.b[block_id].e[el_id].m[m_id]['lng'] = rs.lon;
	Trip.content.b[block_id].e[el_id].m[m_id]['zoom'] = 11;
	
	//reset data values
	data = Trip.content.b[block_id].e[el_id];
	
	//add the marker to the saved marker system
	search_markers.removeLayer(rs.marker); //remove from search results
	rs.marker.addTo(Map); //add to core map layers
	rs.marker.bindPopup("");
	displayed.markers[rs.marker._leaflet_id] = rs.marker //add to displayed marker object
	
	//create the new event
	Editor.add_element('event', data, block_id);
	$('#block_selector').remove();
}



$('body').on('click', '.new_event_from_map', async function(e){
	e.preventDefault();
	let i = $(this).attr('data-mark');
	let rs = search_results[i];
	let blocks = Object.entries(Trip.content.b);
	let block_id = 0;
	let block_looped = false;
	let display_blocks = '';
	
	//if the trip has more than one block, we need to know which block to add this to.
	if(blocks.length == 1){
		let t = Object.keys(Trip.content.b);
		block_id = t[0];
		
		map_event(rs, block_id);
	}else{
		let $block_selector = $('<div/>', {
			'id': 'block_selector',
			'class': 'lightbox'
		});
		
		for (const [block_id, block] of blocks) {
			display_blocks += `
				<div class="block_selector__entry">
					<input id="block_id--${block_id}" type="radio" value="${block_id}" name="block_id" ${block_looped ? '' : 'checked'} />
					<label for="block_id--${block_id}">${block.name}</label>
				</div>
			`;
			
			block_looped = true;
		}
		
		let block_content = `
			<div id="blocks_options">
				<div class="block_selector--close float_right">
					<span class="material-symbols-outlined">close</span>
				</div>
				<h3>Select Block to Add Event</h3>
				<p>Which block would you like this event added to?</p>
				${display_blocks}
				<input id="search_key" type="hidden" name="search_key" value="${i}" />
				<button class="btn btn--primary btn--small margin_top confirm_event_block">Add Event</button>
			</div>
		`;
		
		$block_selector.append(block_content);
		$('.trip').append($block_selector);
		
		$('#block_selector').css("display", "flex").hide().fadeIn(200);
		
		return false;
	}
});



/**Block selector supporting functions **/
$('body').on('click', '.block_selector__entry', async function(e){
	$('.block_selector__entry input').attr('checked', false);
	$(this).find('input').attr('checked', true);
});



$('body').on('click', '.block_selector--close', async function(e){
	$('#block_selector').remove();
});



$('body').on('click', '.confirm_event_block', async function(e){
	let i = $('#search_key').val();
	let rs = search_results[i];
	let block_id = $('.block_selector__entry input:checked').val();
	
	map_event(rs, block_id);
});



$('body').on('click', '.new_marker_from_map', async function(e){
	e.preventDefault();
	let i = $(this).attr('data-mark');
	let rs = search_results[i];
	let blocks = Object.entries(Trip.content.b);
	let event_id = 0;
	let event_looped = false;
	let display_events = '';
	
	
	let $event_selector = $('<div/>', {
		'id': 'event_selector',
		'class': 'lightbox'
	});
	
	for (const [block_id, block] of blocks) {
		for(const [el_id, el] of Object.entries(block.e)){
			if(el.type == 'event'){
				display_events += `
					<div class="event_selector__entry">
						<input id="event_id--${el_id}" type="radio" value="${el_id}" name="event_id" ${event_looped ? '' : 'checked'} />
						<label for="event_id--${el_id}">${el.c.name == '' ? '(Not Named)' : el.c.name}</label>
					</div>
				`;
				
				event_looped = true;
			}
		}
	}
	
	let event_content = `
		<div id="event_options">
			<div class="event_selector--close float_right">
				<span class="material-symbols-outlined">close</span>
			</div>
			<h3>Select Event to Add Marker</h3>
			<p>Which event would you like this marker added to?</p>
			${display_events}
			<input id="search_key" type="hidden" name="search_key" value="${i}" />
			<button class="btn btn--primary btn--small margin_top confirm_event_marker">Add to Event</button>
		</div>
	`;
	
	$event_selector.append(event_content);
	$('.trip').append($event_selector);
	
	$('#event_selector').css("display", "flex").hide().fadeIn(200);
	
	return false;
});



/**Block selector supporting functions **/
$('body').on('click', '.event_selector__entry', async function(e){
	$('.event_selector__entry input').attr('checked', false);
	$(this).find('input').attr('checked', true);
});



$('body').on('click', '.event_selector--close', async function(e){
	$('#event_selector').remove();
});



$('body').on('click', '.confirm_event_marker', async function(e){
	let i = $('#search_key').val();
	let rs = search_results[i];
	let el_id = $('.event_selector__entry input:checked').val();
	
	add_event_marker(rs, el_id);
});


function add_event_marker(rs, el_id){
	console.log('adding event marker');
	
	let el = $(`.e[data-el_id="${el_id}"]`);
	let block_id = el.attr('data-block_id');
	let m_id = random_string(9);
	let data = {};
	let new_marker = {};
	
	console.log(block_id);
	console.log(el_id);
	console.log(m_id);
	
	//prepare trip object
	Trip.content.b[block_id].e[el_id].m = {}; //remove the existing marker reference
	Trip.content.b[block_id].e[el_id].m[m_id] = {};
	
	//Add a new marker to the event element
	Trip.content.b[block_id].e[el_id].m[m_id]['lat'] = rs.lat;
	Trip.content.b[block_id].e[el_id].m[m_id]['lng'] = rs.lon;
	Trip.content.b[block_id].e[el_id].m[m_id]['type'] = Trip.content.b[block_id].e[el_id].c['style'];
	Trip.content.b[block_id].e[el_id].m[m_id]['zoom'] = 11;
	
	//reset data values
	data = Trip.content.b[block_id].e[el_id];
	
	//add the marker to the saved marker system
	search_markers.removeLayer(rs.marker); //remove from search results
	new_marker = L.marker([rs.lat, rs.lon], {icon: icon.get_marker_display(Trip.content.b[block_id].e[el_id].m[m_id])}).addTo(Map); //add & update active
	//new_marker.bindPopup("");
	displayed.markers[new_marker._leaflet_id] = new_marker //add to displayed marker object
	Trip.content.b[block_id].e[el_id].m[m_id]['marker'] = new_marker._leaflet_id;
	
	//create the new event
	$('#event_selector').remove();
	
	Editor.add_element('event', data, block_id, true);
}